import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import config from 'constants/config';
import App from './App';

import 'antd/dist/antd.css';
import 'material-icons/iconfont/filled.css';
import 'material-icons/iconfont/outlined.css';
import './common.css';

import configureStore from './data/store';

const isStageAppHost = () => typeof window !== 'undefined' && window.location.hostname === 'stage-app.getprospect.com';

const initSentry = async () => {
  if (process.env.NODE_ENV === 'development') return;
  if (isStageAppHost()) return;

  const Sentry = await import('@sentry/react');
  const { Integrations } = await import('@sentry/tracing');

  Sentry.init({
    dsn: config.sentryDsn,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [/^\//, /^https:\/\/api\.getprospect\.com/, /^https:\/\/stage-api\.getprospect\.com/],
      }),
    ],
    tracesSampleRate: 0.1,
    ignoreErrors: [
      'TurnstileError',
      'Failed to load Stripe.js',
      'ResizeObserver loop',
      "Failed to execute 'removeChild' on 'Node'",
      "Failed to execute 'insertBefore' on 'Node'",
    ],
    beforeSend(event) {
      const message = event.exception?.values?.[0]?.value || '';
      const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
      const hasOnlyBlobFrames = frames.length > 0 && frames.every((f) => f.filename?.startsWith('blob:'));
      if (hasOnlyBlobFrames) return null;
      if (message === 'Failed to fetch' && !frames.some((f) => f.filename?.includes('/src/'))) {
        return null;
      }
      return event;
    },
  });
};

if (process.env.NODE_ENV !== 'development') {
  initSentry().catch(() => undefined);
}

ReactDOM.render(
  <Provider store={configureStore()}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
